module.exports = __webpack_public_path__ + "static/media/ITC.60879675.txt";